var _ = require('lodash');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/AddressConstants.js').ActionTypes;
var ApplicationActionTypes = require('../constants/ApplicationConstants').ActionTypes;
var AccountTypeActionsTypes = require('../constants/AccountTypeConstants').ActionTypes;
var YourDetailsConstants = require('../constants/YourDetailsConstants.js');
var YourDetailsActionType = YourDetailsConstants.ActionTypes;
var CHANGE_EVENT = 'change';

var _residentResult = [],
    _postalResult = [],
    _residentialOptions = [],
    _postalOptions = [],
    _fetchingAddressOptions = false;

function setValidationResult(id, result, type) {
    if (type === YourDetailsConstants.Values.RESIDENTIAL){
        _residentResult[id] = result;
        _residentialOptions = [];
    }
    else if (type === YourDetailsConstants.Values.POSTAL){
        _postalResult[id] = result;
        _postalOptions = [];
    }
}

function receivedOptions(options, type) {
    // this is to ignore delayed reponse for address API call when the response is not needed anymore,
    // i.e. when user has reseted the screen by setting clicking on a new Account Type
    if (!_fetchingAddressOptions) {
        return;
    }

    if (type === YourDetailsConstants.Values.RESIDENTIAL){
        _residentialOptions = _.cloneDeep(options);
    }
    else if (type === YourDetailsConstants.Values.POSTAL){
        _postalOptions = _.cloneDeep(options);
    }
}

var AddressOptionStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getResidentialValidationResult: function (id) {
        return _residentResult[id];
    },
    getPostalValidationResult: function (id) {
        return _postalResult[id];
    },
    getResidentialOptions: function () {
        return _residentialOptions;
    },
    getPostalOptions: function () {
        return _postalOptions;
    }
});

AddressOptionStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ActionTypes.RECEIVED_VALIDATION_RESULT:
            setValidationResult(action.id, action.result, action.type);
            break;
        case ActionTypes.RECEIVED_OPTIONS:
            receivedOptions(action.options, action.type);
            break;
        case ActionTypes.RESET_RES_VALIDATION:
            _residentResult[action.id] = true;
            break;
        case ActionTypes.RESET_POSTAL_VALIDATION:
            _postalResult[action.id] = true;
            break;
        case YourDetailsActionType.ADD_TRUSTEE:
            _residentResult['ydTrusteeresidential' + action.index] = true;
            _residentResult['ydTrusteepostal' + action.index] = true;
            break;
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
        case AccountTypeActionsTypes.SELECT_ACCOUNT_TYPE:
            _residentResult=[];
            _postalResult=[];
            _residentialOptions=[];
            _postalOptions = [];
            _fetchingAddressOptions = false;
            break;
        case ActionTypes.FETCHING_ADDRESS_OPTIONS:
            _fetchingAddressOptions = true;
            break;
        default:
            return true;
    }
    AddressOptionStore.emitChange();
    return true;
});

module.exports = AddressOptionStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/AddressStore.js